<div class="max-w-layout">
    <ng-content />
</div>
